import { notification } from 'antd';
import type { TooltipPlacement } from 'antd/es/tooltip';
import { TFunctionResult } from 'i18next';
import { ReactNode } from 'react';

export const openToast = (toast?: Toast): void => {
  notification[toast?.type || 'info']({
    message: toast?.message || 'info',
    description: toast?.description,
    placement: toast?.placement || 'bottomRight',
    duration: toast?.duration,
    btn: toast?.btn
  });
};

export interface Toast {
  type?: string;
  placement?: TooltipPlacement;
  message?: string;
  description?: string | TFunctionResult | ReactNode;
  btn?: string | TFunctionResult | ReactNode;
  duration?: number;
}
